'use client';

import { useCallback } from 'react';
import { useTranslations } from 'next-intl';
import type { DocumentationFileCategory } from './applicationDocumentation.types';
import type { ApplicationDocumentationViewModel } from './applicationDocumentationView.types';
import { ApplicationDocumentationFileList } from './ApplicationDocumentationFileList';
import { ApplicationDocumentationUrlList } from './ApplicationDocumentationUrlList';

type ApplicationDocumentationCategoryFilesProps = {
  category: DocumentationFileCategory;
  viewModel: ApplicationDocumentationViewModel;
};

export const ApplicationDocumentationCategoryFiles = ({
  category,
  viewModel,
}: ApplicationDocumentationCategoryFilesProps) => {
  const tCommon = useTranslations('designSystem.common');
  const { onRemoveFile, onDownloadFile } = viewModel;
  const handleRemoveFile = useCallback(
    ({ fileIndex }: { fileIndex: number }) =>
      onRemoveFile({ category, fileIndex }),
    [category, onRemoveFile],
  );
  const handleDownloadFile = useCallback(
    ({ fileIndex }: { fileIndex: number }) =>
      onDownloadFile({ category, fileIndex }),
    [category, onDownloadFile],
  );

  return (
    <>
      <ApplicationDocumentationFileList
        files={viewModel.visibleFilesByCategory[category]}
        onRemoveFile={handleRemoveFile}
        onDownloadFile={handleDownloadFile}
        deleteAriaLabel={tCommon('remove')}
        omitFileRowId={viewModel.omitFileRowId}
        isReadOnly={viewModel.isReadOnly}
      />
      {category === 'application' ? (
        <ApplicationDocumentationUrlList
          urls={viewModel.visibleDocumentationUrls}
          onRemoveUrl={viewModel.onRemoveUrl}
          deleteAriaLabel={tCommon('delete')}
          omitUrlRowIndex={viewModel.omitUrlRowIndex}
          isReadOnly={viewModel.isReadOnly}
        />
      ) : null}
    </>
  );
};
